import BaseChart from './BaseChart';

/**
 * Waterfall chart implementation using VChart
 */
class WaterfallChart extends BaseChart {
  /**
   * Get chart specification for waterfall chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    // Waterfall specific fields — auto-detect from data when not provided
    const categoryField = this.options.categoryField || this._resolveNameField();
    const valueField = this._resolveValueField();
    const typeField = this.options.typeField; // Optional field to indicate increase/decrease
    
    return {
      type: 'waterfall',
      data,
      categoryField,
      valueField,
      typeField,
      
      // Colors for different types of bars
      total: {
        style: {
          fill: '#5B8FF9',
          ...this.options.totalStyle
        }
      },
      increase: {
        style: {
          fill: '#5AD8A6',
          ...this.options.increaseStyle
        }
      },
      decrease: {
        style: {
          fill: '#F6BD16',
          ...this.options.decreaseStyle
        }
      },
      
      // Bar styling
      bar: {
        style: {
          cornerRadius: 2,
          ...this.options.barStyle
        },
        state: {
          hover: {
            stroke: '#fff',
            lineWidth: 2
          },
          ...this.options.barState
        }
      },
      
      // Connector line styling
      connector: {
        visible: this.options.showConnector !== false,
        style: {
          stroke: '#aaa',
          lineWidth: 1,
          lineDash: [4, 2],
          ...this.options.connectorStyle
        }
      },
      
      // Label configuration
      label: {
        visible: this.options.showLabels !== false,
        position: this.options.labelPosition || 'top',
        style: {
          fontSize: 12,
          fontWeight: 'normal',
          ...this.options.labelStyle
        },
        formatter: this.options.labelFormatter
      },
      
      // Axes configuration
      axes: [
        {
          orient: 'bottom',
          type: 'band',
          ...this.options.xAxis
        },
        {
          orient: 'left',
          type: 'linear',
          grid: {
            visible: true,
            ...this.options.gridStyle
          },
          ...this.options.yAxis
        }
      ],
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
}

export default WaterfallChart; 